import React from 'react';
import { Tooltip } from '@material-ui/core';
import AuditTrailTimeline from '../AuditTrailTimeline';
import { CommentList } from '../CommentItem';
import { formatValue } from '../../utils';
import {
    rightPanel,
    rightPanelContent,
    infoCardsGrid,
    selectFieldWrapper,
    selectFieldLabel,
    selectFieldLabelRequired,
    selectFieldInput,
    infoCard,
    infoCardIconWrap,
    infoCardIcon,
    infoCardText,
    infoCardLabel,
    infoCardValue,
    tabBar,
    tab,
    tabActive,
    tabContent,
} from './RightPanel.style';

const RightPanel = ({
    opportunity,
    auditTrails,
    workflowComments,
    supplementalInfoComments,
    activeTab,
    onTabChange,
    infoCardsConfig,
    rightPanelTabs,
    avatarColors,
}) => {
    return (
        <div style={rightPanel}>
            {opportunity && (
                <div style={rightPanelContent}>
                    <div style={selectFieldWrapper}>
                        <div style={selectFieldLabel}>
                            <span>Select Opportunity</span>
                            <span style={selectFieldLabelRequired}>*</span>
                        </div>
                        <div style={selectFieldInput}>{opportunity?.opportunityTitle || '—'}</div>
                    </div>

                    <div style={infoCardsGrid}>
                        {infoCardsConfig.map((card) => {
                            const val = formatValue(opportunity?.[card.valueKey], card);
                            return (
                                <Tooltip key={card.valueKey} title={`${card.label}: ${val}`} arrow placement="top">
                                    <div style={infoCard}>
                                        <div style={infoCardIconWrap}>
                                            <img src={card.icon} alt="" style={infoCardIcon} />
                                        </div>
                                        <div style={infoCardText}>
                                            <div style={infoCardLabel}>{card.label}</div>
                                            <div style={infoCardValue}>{val}</div>
                                        </div>
                                    </div>
                                </Tooltip>
                            );
                        })}
                    </div>
                </div>
            )}

            <div style={tabBar}>
                {rightPanelTabs.map((t) => (
                    <div
                        key={t.key}
                        style={activeTab === t.key ? tabActive : tab}
                        onClick={() => onTabChange(t.key)}
                    >
                        {t.label}
                    </div>
                ))}
            </div>

            <div style={tabContent}>
                {activeTab === 'auditTrails' && <AuditTrailTimeline auditTrails={auditTrails} />}

                {activeTab === 'comments' && (
                    <CommentList
                        comments={workflowComments}
                        dateKey="datetime"
                        avatarColors={avatarColors}
                        emptyMessage="No comments to show"
                    />
                )}

                {activeTab === 'supplementaryComments' && (
                    <CommentList
                        comments={supplementalInfoComments}
                        dateKey="date"
                        avatarColors={avatarColors}
                        emptyMessage="No supplementary comments to show"
                    />
                )}
            </div>
        </div>
    );
};

export default RightPanel;
